import { OBJECT_POLICY_ACTIONS } from './rbacConstants';

export function walkCatalogModules(modules, callback) {
  (modules || []).forEach((module) => {
    callback(module);
    walkCatalogModules(module.children, callback);
  });
}

export function countModuleEnabled(node, grants = {}) {
  let enabled = 0;
  let total = 0;

  (node.features || []).forEach((feature) => {
    total += 1;
    if (grants.features?.[feature.codename]) {
      enabled += 1;
    }
  });

  (node.objects || []).forEach((obj) => {
    const modelKey = (obj.model || '').toLowerCase();
    const policy = grants.objects?.[modelKey] || obj.default_policy || {};
    OBJECT_POLICY_ACTIONS.forEach((action) => {
      total += 1;
      if (policy[action.key]) {
        enabled += 1;
      }
    });
  });

  (node.children || []).forEach((child) => {
    const childCounts = countModuleEnabled(child, grants);
    enabled += childCounts.enabled;
    total += childCounts.total;
  });

  return { enabled, total };
}

export function grantsFromCatalog(catalog) {
  const features = {};
  const objects = {};

  walkCatalogModules(catalog?.modules, (module) => {
    (module.features || []).forEach((feature) => {
      features[feature.codename] = Boolean(feature.default_granted);
    });
    (module.objects || []).forEach((obj) => {
      const modelKey = (obj.model || '').toLowerCase();
      if (objects[modelKey]) {
        return;
      }
      const policy = {};
      OBJECT_POLICY_ACTIONS.forEach((action) => {
        policy[action.key] = Boolean(obj.default_policy?.[action.key]);
      });
      objects[modelKey] = policy;
    });
  });

  return {
    features,
    objects,
    resources: { accounts: [], campaigns: [], form_fields: [] },
    record_actions: {},
  };
}

export function mergeGrantsWithCatalog(catalog, grants = {}) {
  const defaults = grantsFromCatalog(catalog);
  return {
    features: { ...defaults.features, ...(grants.features || {}) },
    objects: {
      ...defaults.objects,
      ...Object.fromEntries(
        Object.entries(grants.objects || {}).map(([model, policy]) => [
          model.toLowerCase(),
          { ...(defaults.objects[model.toLowerCase()] || {}), ...policy },
        ])
      ),
    },
    resources: {
      accounts: Array.isArray(grants.resources?.accounts) ? grants.resources.accounts : [],
      campaigns: Array.isArray(grants.resources?.campaigns) ? grants.resources.campaigns : [],
      form_fields: Array.isArray(grants.resources?.form_fields) ? grants.resources.form_fields : [],
    },
    record_actions: grants.record_actions || {},
  };
}

export function formatFeatureLabel(name = '') {
  return String(name)
    .replace(/^can_/i, '')
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
